<div class="card card-bordered ">
  <div class="card-body" *ngIf="chartOptions">
    <highcharts-chart [Highcharts]="Highcharts" [options]="chartOptions" style="display: block;">
    </highcharts-chart>
  </div>
</div>
